import { render, staticRenderFns } from "./honor_supplement.vue?vue&type=template&id=2afad8f2&scoped=true&"
import script from "./honor_supplement.vue?vue&type=script&lang=js&"
export * from "./honor_supplement.vue?vue&type=script&lang=js&"
import style0 from "./honor_supplement.vue?vue&type=style&index=0&id=2afad8f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afad8f2",
  null
  
)

export default component.exports